import apiClient from '@u/apiClient'
import actionsScreenConfig from '@/store/modules/settings/management/screenSettings/actions.screenConfig'
import GetScreenListController from '@/wayfinder/actions/App/Http/Controllers/Screen/GetScreenListController'
import GetScreenByIdController from '@/wayfinder/actions/App/Http/Controllers/Screen/GetScreenByIdController'
import GetScreenDataByIdController from '@/wayfinder/actions/App/Http/Controllers/Screen/GetScreenDataByIdController'
import GetScreenScreenshotDataByIdController from '@/wayfinder/actions/App/Http/Controllers/Screen/GetScreenScreenshotDataByIdController'
import ActionScreenRebootByIdController from '@/wayfinder/actions/App/Http/Controllers/Screen/ActionScreenRebootByIdController'
import CreateScreenController from '@/wayfinder/actions/App/Http/Controllers/Screen/CreateScreenController'
import UpdateScreenController from '@/wayfinder/actions/App/Http/Controllers/Screen/UpdateScreenController'
import GetScreenDossierByLocationController from '@/wayfinder/actions/App/Http/Controllers/Screen/GetScreenDossierByLocationController'
import GetScreenListDossierByLocationController from '@/wayfinder/actions/App/Http/Controllers/Screen/GetScreenListDossierByLocationController'
import GetScreenListDirectionByLocationController from '@/wayfinder/actions/App/Http/Controllers/Screen/GetScreenListDirectionByLocationController'
import GetScreenConfigEventsController from '@/wayfinder/actions/App/Http/Controllers/Screen/GetScreenConfigEventsController'
import GetRoomOccupationController from '@/wayfinder/actions/App/Http/Controllers/Screen/GetRoomOccupationController'
import GetCoffinPlacingController from '@/wayfinder/actions/App/Http/Controllers/Screen/GetCoffinPlacingController'
import GetItemController from '@/wayfinder/actions/App/Http/Controllers/Screen/GetItemController'
import UpdateScreenAccessCodeController from '@/wayfinder/actions/App/Http/Controllers/Screen/UpdateScreenAccessCodeController'
import LogoffScreenController from '@/wayfinder/actions/App/Http/Controllers/Screen/LogoffScreenController'
import GetNewModelController from '@/wayfinder/actions/App/Http/Controllers/NewModel/GetNewModelController'

export default {
  ...actionsScreenConfig,

  fetchScreenSettingsList({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetScreenListController.get())
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchNewScreenSetting({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetNewModelController.get({ query: { model: 'Screen' } }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchScreenSetting({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetScreenByIdController['/api/screen-settings/{screen}'].get({
            screen: payload.screen_id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchScreenSettingData({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetScreenDataByIdController.get({ screen: payload.screen_id }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchScreenSettingScreenshot({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetScreenScreenshotDataByIdController.get({
            screen: payload.screen_id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  rebootScreen({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          ActionScreenRebootByIdController.get({ screen: payload.screen_id })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  storeScreen({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(CreateScreenController.post(), payload)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  updateScreen({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(UpdateScreenController.put({ screen: payload.id }), payload)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchDossierByLocation({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetScreenDossierByLocationController.get(), {
          params: payload.params
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchListDossiersByLocation({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetScreenListDossierByLocationController.get(), {
          params: payload.params
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchListDirectionByLocation({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetScreenListDirectionByLocationController.get(), {
          params: payload.params
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  getEvents({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetScreenConfigEventsController.get(), {
          params: payload
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  getRoomOccupation({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetRoomOccupationController.get(), {
          params: payload
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  getCoffinPlacing({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetCoffinPlacingController.get(), {
          params: payload
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  getItem({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetItemController.post(), payload)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  saveAccessCode({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdateScreenAccessCodeController.post({ screen: payload.screen_id }),
          payload
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  logoffScreen({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          LogoffScreenController.post({ screen: payload.screen_id }),
          payload
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
}
